import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Double from '../../../../java/lang/Double';
import Cloneable from '../../../../java/lang/Cloneable';
var CoordinateSequence = /*#__PURE__*/function () {
  function CoordinateSequence() {
    _classCallCheck(this, CoordinateSequence);
  }
  _createClass(CoordinateSequence, [{
    key: "getM",
    value: function getM(index) {
      if (this.hasM()) {
        var mIndex = this.getDimension() - this.getMeasures();
        return this.getOrdinate(index, mIndex);
      } else {
        return Double.NaN;
      }
    }
  }, {
    key: "setOrdinate",
    value: function setOrdinate(index, ordinateIndex, value) {}
  }, {
    key: "getZ",
    value: function getZ(index) {
      if (this.hasZ()) return this.getOrdinate(index, 2);else return Double.NaN;
    }
  }, {
    key: "size",
    value: function size() {}
  }, {
    key: "getOrdinate",
    value: function getOrdinate(index, ordinateIndex) {}
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1) {
        var i = arguments[0];
      } else if (arguments.length === 2) {
        var index = arguments[0],
          coord = arguments[1];
      }
    }
  }, {
    key: "getCoordinateCopy",
    value: function getCoordinateCopy(i) {}
  }, {
    key: "createCoordinate",
    value: function createCoordinate() {}
  }, {
    key: "getDimension",
    value: function getDimension() {}
  }, {
    key: "hasM",
    value: function hasM() {
      return this.getMeasures() > 0;
    }
  }, {
    key: "getX",
    value: function getX(index) {}
  }, {
    key: "hasZ",
    value: function hasZ() {
      return this.getDimension() - this.getMeasures() > 2;
    }
  }, {
    key: "getMeasures",
    value: function getMeasures() {
      return 0;
    }
  }, {
    key: "expandEnvelope",
    value: function expandEnvelope(env) {}
  }, {
    key: "copy",
    value: function copy() {}
  }, {
    key: "getY",
    value: function getY(index) {}
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {}
  }, {
    key: "interfaces_",
    get: function get() {
      return [Cloneable];
    }
  }]);
  return CoordinateSequence;
}();
export { CoordinateSequence as default };
CoordinateSequence.X = 0;
CoordinateSequence.Y = 1;
CoordinateSequence.Z = 2;
CoordinateSequence.M = 3;